export default {
    error: 1,
    warning: 2,
    success: 3,
    info: 4,
}
